<template>
	<div class="news">
		<div class="news-box">
			<div class="title">{{ detail.title }}</div>
			<div class="sub">
				<span>{{ detail.pushDate }}</span>
				<span>{{ detail.mediaChannel }}</span>
			</div>
			<div class="info" v-html="detail.internalInfo"></div>
			<div class="page">
				<div class="item">
					<div v-if="prv" @click="prev()">
						<img style="margin-right: 8px;" src="@/assets/images/arrow_left.png" />
						<!-- <span>上一篇：</span> -->
						<span>{{ prv.title }}</span>
					</div>
				</div>
				<div class="item">
					<div v-if="next" @click="handleNext()">
						<!-- <span>下一篇：</span> -->
						<span>{{ next.title }}</span>
						<img style="margin-left: 8px;" src="@/assets/images/arrow_right.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { queryInfoFromH5, queryNextOrPre } from '@/axios/api.js'
export default {
	data() {
		return {
			detail: {},
			prv: undefined,
			next: undefined,
		}
	},
	created() {

		this.init(this.$route.query.id, this.$route.query.nodeNum)

	},
	mounted() {

	},
	computed: {},
	watch: {},
	methods: {
		init(id, nodeNum) {
			this.detail = {}
			this.prv = undefined
			this.next = undefined

			let params = {
				id,
				tab: this.$route.query.tab,
				nodeNum,
			}
			queryInfoFromH5(params).then(res => {
				this.detail = res.data.data

				// 上一个
				if (this.detail.pageNum > 1) {
					let params1 = {
						pageNum: this.detail.pageNum - 1,
						tab: this.$route.query.tab,
					}
					queryNextOrPre(params1).then(res1 => {
						this.prv = res1.data.data
					})
				}


				// 下一个
				// todo
				let params2 = {
					pageNum: this.detail.pageNum + 1,
					tab: this.$route.query.tab,
				}
				queryNextOrPre(params2).then(res2 => {
					this.next = res2.data.data
				})
			})
		},

		prev() {
			if(this.prv.jumpType === 'OUT_LINK'){
				window.open(this.prv.outLink)
			}else{
				this.init(this.prv.id, this.prv.pageNum)
			}
		},

		handleNext() {
			if(this.next.jumpType === 'OUT_LINK'){
				window.open(this.next.outLink)
			}else{
				this.init(this.next.id, this.next.pageNum)
			}
		}
	},
	beforeDestroy() {

	},
	components: {

	}
}
</script>

<style scoped lang="less">
.news-box {
	padding: 0.8rem 0 .6rem 0;
	background: #fff url('../../assets/images/news_bg.png') top center no-repeat;
	background-size: cover;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;

	.title {
		font-size: .24rem;
		font-weight: bold;
		margin-bottom: .16rem
	}

	.sub {
		margin-bottom: .3rem;

		span {
			padding: 0 .10rem;
			font-size: .14rem;
			color: #AEB3C0;
		}
	}

	.info {
		padding: 0 .16rem;
		width: 100%;
		box-sizing: border-box;

	}

	::v-deep .info img {
		max-width: 100%;
		height: auto;
		display: block;
		margin: 0 auto;
	}
}

.page {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;
	width: 100%;
	padding: 0.7rem .24rem 0 .24rem;
	box-sizing: border-box;

	.item {
		cursor: pointer;
		margin-bottom: .3rem;
		
		
		div{
			display: flex;
			align-items: center;
		}

		img {
			width: .14rem;
			height: auto;
		}

		span {
			color: #24242A;
			font-size: .14rem;
			font-weight: bold;
		}
	}
}
</style>